// apps/client/src/ui/screens/creator.tsx (M0-T16) — the needsProfile phase screen, and later "edit your character"
import { FRIEND_COLORS } from '@whiskerton/content';
import { useState } from 'react';
import { api } from '../../api/endpoints';
import { HttpError } from '../../api/http';
import { DEFAULT_LOOK } from '../../characters/look';
import { useGame } from '../../state/store';
import { CreatorForm } from '../creator/CreatorForm';
import { useT } from '../i18n';
import type { ScreenDef } from '../router';

declare module '../router' { interface ScreenParams { creator: undefined } }

function Creator({ close }: { close: () => void }) {
  const t = useT();
  const me = useGame((s) => s.me);
  const firstTime = useGame((s) => s.phase === 'needsProfile');
  const [saving, setSaving] = useState(false);
  const friend = me?.towns[0]?.color ?? FRIEND_COLORS[0];
  return (
    <div className="layer-full hit">
      <CreatorForm initial={{ name: me?.profile?.name ?? '', look: me?.profile?.look ?? DEFAULT_LOOK }} friend={friend} saving={saving}
        title={firstTime ? t('creator.title') : t('creator.editTitle')}
        onSave={async (v) => {
          setSaving(true);
          try {
            const { profile } = await api.putProfile(v);
            const s = useGame.getState();
            if (s.me) s.setMe({ ...s.me, profile });
            if (s.phase === 'needsProfile') s.setPhase('towns'); else close();
          } catch (e) {
            useGame.getState().toast(e instanceof HttpError ? (`errors.${e.error}` as const) : 'errors.server_error', undefined, 'warn');
          } finally { setSaving(false); }
        }} />
    </div>
  );
}
export const screen: ScreenDef<'creator'> = { id: 'creator', layer: 'full', component: Creator };
